import React, { Fragment } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import uuid from 'react-uuid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@material-ui/icons/Search';
import history from '../../services/router/history';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  formControl: {
    width: '100%',
  },
  datePicker: {
    marginTop: theme.spacing(1),
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    height: '100%',
    alignItems: 'flex-end',
    paddingBottom: theme.spacing(0.5),
  },
  button: {
    minWidth: 48,
  }
}));

const SearchBar = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    from, handleFrom, to, handleTo, handleSubmit, selector, handleSelector,
    fields, value, handleValue, status, statuses, handleStatus, statusLabel,
    location, locations, handleLocation
  } = props;

  const refresh = () => {
    history.push('/');
    history.goBack();
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={1}>
        <form
          onSubmit={handleSubmit}
          noValidate
        >
          <Grid container spacing={2} alignItems="flex-end">
            {/* Field Selector */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControl className={classes.formControl} size="small">
                <InputLabel>{t('filters.select.field')}</InputLabel>
                <Select
                  name="field"
                  value={selector}
                  onChange={handleSelector}
                >
                  {fields.map(filter => (
                    <MenuItem key={uuid()} value={filter.value}>{filter.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Date Pickers or Text Field */}
            {selector === 'createdAt' || selector === 'date' ? (
              <Fragment>
                <Grid item xs={6} sm={3} md={2}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    name="from"
                    fullWidth
                    autoOk={true}
                    format="DD/MM/YYYY"
                    margin="normal"
                    label={t('filters.from.value')}
                    value={from}
                    onChange={handleFrom}
                    size="small"
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    name="to"
                    fullWidth
                    autoOk={true}
                    format="DD/MM/YYYY"
                    margin="normal"
                    label={t('filters.to.value')}
                    value={to}
                    onChange={handleTo}
                    size="small"
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} sm={6} md={locations ? 2 : (statuses ? 3 : 4)}>
                <FormControl className={classes.formControl}>
                  <TextField
                    name="value"
                    label={t('filters.text_field.value')}
                    fullWidth
                    disabled={(selector === 'active' || selector === 'deactivated')}
                    InputLabelProps={{ shrink: true }}
                    value={value}
                    onChange={handleValue}
                    size="small"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
            )}

            {/* Status Selector */}
            {statuses && (
              <Grid item xs={12} sm={6} md={2}>
                <FormControl className={classes.formControl} size="small">
                  <InputLabel id="status_select">{statusLabel || t('filters.status.value')}</InputLabel>
                  <Select
                    labelId="status_select"
                    name="status"
                    value={status || ''}
                    onChange={handleStatus}
                  >
                    <MenuItem key={uuid()} value="">--</MenuItem>
                    {statuses.length > 0 && statuses.map(status => (
                      <MenuItem key={uuid()} value={status.value}>
                        {t(`${status.name}`)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Location Selector */}
            {locations && (
              <Grid item xs={12} sm={6} md={2}>
                <FormControl className={classes.formControl} size="small">
                  <InputLabel id="location_select">{t('filters.location.value')}</InputLabel>
                  <Select
                    labelId="location_select"
                    name="location"
                    value={location}
                    onChange={handleLocation}
                  >
                    <MenuItem key={uuid()} value="">--</MenuItem>
                    {locations.map(location => (
                      <MenuItem key={uuid()} value={location.value}>
                        {t(`${location.name}`)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Action Buttons */}
            <Grid item xs={12} sm={6} md={2}>
              <Box className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  startIcon={<SearchIcon />}
                  fullWidth
                >
                  {t('filters.button.apply')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => refresh()}
                  className={classes.button}
                >
                  <ClearIcon />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </div>
  );
};

export default SearchBar;
